export default [
  {
    path: "/d0de8f2782dfaaedff1a288b",
    children: [
      {
        path: "d147d4ac3c7c612ef9e1fed4",
        name: "upload.grades",
        meta: {
        title: 'Upload Grades',
          authRequired: true,
        //   acc: [],
        },
        component: ()=> import('@/views/grades/new.vue')
      },
    ],
  },
];
